import { Children, createElement } from 'react'

function flatten(text, child) {
  return typeof child === 'string'
    ? text + child
    : Children.toArray(child.props.children).reduce(flatten, text)
}

function Heading(props) {
  const children = Children.toArray(props.children)
  const text = children.reduce(flatten, '')
  const slug = text.toLowerCase().replace(/\W/g, '-')
  return createElement('h' + props.level, { id: slug }, props.children)
}

export default Heading
